import { Link } from 'react-router-dom';
import React from 'react';

interface IProps {
    label: string;
    icon: React.ComponentType<React.SVGProps<SVGSVGElement>>;
    link?: string;
    onClick?: () => void;
    variant?: 'primary' | 'secondary';
}

const AccountMenuItemButton = ({ icon: IconComponent, link, label, variant = 'primary', onClick }: IProps) => {
    const _content = () => {
        return <div
            className={`flex flex-col items-center justify-start gap-3 py-6 md:py-10 px-4 border rounded-3xl transition-colors font-medium cursor-pointer h-full ${variant == 'primary' ? ' border-neutral-700 bg-neutral-900 hover:bg-neutral-950' : 'border-neutral-700 bg-[#008DD2] hover:bg-[#007CC1]'}`}>
            <IconComponent className={'w-10 h-10'} />
            <h3 className={'text-lg md:text-xl text-center'}>{label}</h3>
        </div>;
    };
    if (link) {
        return <Link to={link}>
            {_content()}
        </Link>;
    }
    if (onClick) {
        return <button onClick={onClick}>
            {_content()}
        </button>;
    }
    return _content();
};

export default AccountMenuItemButton;